import {useState, useEffect} from "react";
import APICallService from "../api/apiCallService";
import {privacyPolicy as privacyPolicyEndpoint} from "../api/apiEndPoints";
import Loader from "../Global/loader";

const PrivacyPolicy = () => {
    const [privacyPolicyData, setPrivacyPolicyData] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPrivacyPolicy = async () => {
            try {
                setLoading(true);
                const apiService = new APICallService(privacyPolicyEndpoint, {});
                const response = await apiService.callAPI();

                if (response) {
                    let parsedResponse = response;
                    if (typeof response === "string") {
                        try {
                            parsedResponse = JSON.parse(response);
                        } catch (e) {
                            return;
                        }
                    }

                    if (parsedResponse.data) {
                        setPrivacyPolicyData(parsedResponse.data);
                    }
                }
            } catch (error) {
                // Error handling
            } finally {
                setLoading(false);
            }
        };

        fetchPrivacyPolicy();
    }, []);

    return (
        <>
            <div className="main-hero-sec wrapper overflow-hidden">
                <div className="container py-5 py-md-5">
                    <div className="row align-items-center gy-5">
                        <div className="col-lg-12 text-center">
                            <h1 className="fs-50 fw-bolder mb-5 main-ease-animator1">Privacy Policy</h1>
                        </div>
                    </div>
                </div>
            </div>

            <div className="wrapper pb-8 pb-lg-10">
                <div className="container">
                    {loading ? (
                        <div className="text-center p-4">
                            <Loader loading={loading} />
                        </div>
                    ) : privacyPolicyData ? (
                        <div className="fs-18 fw-medium" dangerouslySetInnerHTML={{__html: privacyPolicyData}} />
                    ) : (
                        <p className="fs-18 fw-medium">No privacy policy data available.</p>
                    )}
                </div>
            </div>
        </>
    );
};

export default PrivacyPolicy;
